$(document).ready(function () {
  ysscount = 0;

  // Loop through each gallery element
  $(".ky_custom_gallery_swiper").each(function () {
    ysscount++;
    var this_item = $(this);
    this_item.addClass("swiper customswiper" + ysscount);

    // Get necessary data attributes
    var desk_slider = this_item.attr("data-desktop_swiper");
    var mob_slider = this_item.attr("data-mobile_swiper");
    var desk_item = this_item.attr("data-desktop_items");
    var mob_item = this_item.attr("data-mobile_items");
    var ipad_item = this_item.attr("data-ipad_items");
    var ipad_item_horizontal = this_item.attr("data-ipad_horizontal_items");
    var ipad_item_vertical = this_item.attr("data-ipad_vertical_items");
    var slider_mode = this_item.attr("data-mode");
    var swiper_arrows = this_item.attr("data-swiper-style-arrow");
    var swiper_style = this_item.attr("data-swiper_style");
    var slider_autoplay = this_item.attr("data-slider-autoplay");
    var slider_center = this_item.attr("data-slider-center");
    var slider_effect = this_item.attr("data-slider-effect");
    var slider_desktop_padding = this_item.attr("data-desktop-padding");
    var slider_ipad_horizontal_padding = this_item.attr(
      "data-ipad-horizontal-padding"
    );
    var slider_ipad_vertical_padding = this_item.attr(
      "data-ipad-vertical-padding"
    );
    var slider_mobile_padding = this_item.attr("data-mobile-padding");
    var desktop_offset = this_item.attr("data-desktop-offset");
    var mobile_offset = this_item.attr("data-mobile-offset");
    var ipad_vertical_offset = this_item.attr("data-ipad-vertical-offset");
    var ipad_horizontal_offset = this_item.attr("data-ipad-horizontal-offset");
    var slider_loop = this_item.attr("data-slider-loop");

    var swiper_navigation = {};
    var swiper_pagination = {};
    var slider_autoplay_start = {};
    var is_slider_loop = slider_loop !== "false"; // Default is true
    var is_slider_center = slider_center !== "false"; // Default is true

    if (swiper_arrows == "true") {
      this_item.append(
        '<div class="swiper-button-next swiper_arrows customswiper_next' +
          ysscount +
          '"></div><div class="swiper-button-prev swiper_arrows customswiper_prev' +
          ysscount +
          '"></div>'
      );
      swiper_navigation = {
        nextEl: ".customswiper_next" + ysscount,
        prevEl: ".customswiper_prev" + ysscount,
      };
    }

    if (swiper_style == "dots") {
      this_item.append('<div class="swiper-pagination"></div>');
      swiper_pagination = {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      };
    } else if (swiper_style == "progress_bar") {
      this_item.append('<div class="swiper-pagination"></div>');
      swiper_pagination = {
        el: ".swiper-pagination",
        type: "progressbar",
        clickable: true,
      };
    } else if (swiper_style == "fraction") {
      this_item.append('<div class="swiper-pagination"></div>');
      swiper_pagination = {
        el: ".swiper-pagination",
        type: "fraction",
        clickable: true,
      };
    } else {
      swiper_pagination = {};
    }

    slider_autoplay_start =
      slider_autoplay == "true"
        ? {
            delay: 3500,
            disableOnInteraction: false,
          }
        : {
            delay: 250000000000,
            disableOnInteraction: true,
          };
    var partner_swiper = new Swiper(".customswiper" + ysscount, {
      spaceBetween: 0,
      navigation: swiper_navigation,
      effect: slider_effect === "fade" ? "fade" : "",
      pagination: swiper_pagination,
      loop: is_slider_loop,
      autoplay: slider_autoplay_start,
      centeredSlides: is_slider_center,
      breakpoints: {
        0: {
          slidesPerView: mob_item,
          spaceBetween: slider_mobile_padding,
          slidesOffsetBefore: mobile_offset,
        },
        481: {
          slidesPerView: ipad_item_vertical,
          spaceBetween: slider_ipad_vertical_padding,
          slidesOffsetBefore: ipad_vertical_offset,
        },
        786: {
          slidesPerView: ipad_item_horizontal,
          spaceBetween: slider_ipad_horizontal_padding,
          slidesOffsetBefore: ipad_horizontal_offset,
        },
        1100: {
          slidesPerView: desk_item,
          spaceBetween: slider_desktop_padding,
          slidesOffsetBefore: desktop_offset,
        },
      },
    });
    //    console.log(desk_slider);
    //    console.log(mob_slider);
    //    // Initialize desktop slider only if desk_slider is true
    //    if(desk_slider == 'true' && mob_slider == 'true' ){
    //      console.log("desk_slider-mob-slider-both-true");
    //      var partner_swiper = new Swiper('.customswiper' + ysscount, {
    //        spaceBetween: 0,
    //        navigation: swiper_navigation,
    //        effect: (slider_effect === 'fade' ? "fade" : ""),
    //        pagination: swiper_pagination,
    //        loop: is_slider_loop,
    //        autoplay: slider_autoplay_start,
    //        centeredSlides: is_slider_center,
    //        breakpoints: {
    //          0: {
    //            slidesPerView: mob_item,
    //            spaceBetween: slider_mobile_padding,
    //            slidesOffsetBefore: mobile_offset
    //          },
    //          481: {
    //            slidesPerView: ipad_item_vertical,
    //            spaceBetween: slider_ipad_vertical_padding,
    //            slidesOffsetBefore: ipad_vertical_offset
    //          },
    //          786: {
    //            slidesPerView: ipad_item_horizontal,
    //            spaceBetween: slider_ipad_horizontal_padding,
    //            slidesOffsetBefore: ipad_horizontal_offset
    //          },
    //          1100: {
    //            slidesPerView: desk_item,
    //            spaceBetween: slider_desktop_padding,
    //            slidesOffsetBefore: desktop_offset
    //          }
    //        }
    //      });
    //    }
    //    else{
    //      console.log("slider-true");
    //    if (desk_slider == 'true' && window.matchMedia("(min-width: 1100px)").matches) {
    //      console.log("desk_slider-true");
    //      var partner_swiper = new Swiper('.customswiper' + ysscount, {
    //        spaceBetween: 0,
    //        navigation: swiper_navigation,
    //        effect: (slider_effect === 'fade' ? "fade" : ""),
    //        pagination: swiper_pagination,
    //        loop: is_slider_loop,
    //        autoplay: slider_autoplay_start,
    //        centeredSlides: is_slider_center,
    //        breakpoints: {
    //          0: {
    //            slidesPerView: mob_item,
    //            spaceBetween: slider_mobile_padding,
    //            slidesOffsetBefore: mobile_offset
    //          },
    //          481: {
    //            slidesPerView: ipad_item_vertical,
    //            spaceBetween: slider_ipad_vertical_padding,
    //            slidesOffsetBefore: ipad_vertical_offset
    //          },
    //          786: {
    //            slidesPerView: ipad_item_horizontal,
    //            spaceBetween: slider_ipad_horizontal_padding,
    //            slidesOffsetBefore: ipad_horizontal_offset
    //          },
    //          1100: {
    //            slidesPerView: desk_item,
    //            spaceBetween: slider_desktop_padding,
    //            slidesOffsetBefore: desktop_offset
    //          }
    //        }
    //      });
    //    }

    //    // Initialize mobile slider only if mob_slider is true
    //    if (mob_slider == 'true' && window.matchMedia("(max-width: 1100px)").matches) {
    //       console.log("mob_slider-true");
    //      var partner_swiper = new Swiper('.customswiper' + ysscount, {
    //        spaceBetween: 0,
    //        navigation: swiper_navigation,
    //        effect: (slider_effect === 'fade' ? "fade" : ""),
    //        pagination: swiper_pagination,
    //        loop: is_slider_loop,
    //        autoplay: slider_autoplay_start,
    //        centeredSlides: is_slider_center,
    //        breakpoints: {
    //          0: {
    //            slidesPerView: mob_item,
    //            spaceBetween: slider_mobile_padding,
    //            slidesOffsetBefore: mobile_offset
    //          },
    //          481: {
    //            slidesPerView: ipad_item_vertical,
    //            spaceBetween: slider_ipad_vertical_padding,
    //            slidesOffsetBefore: ipad_vertical_offset
    //          },
    //          786: {
    //            slidesPerView: ipad_item_horizontal,
    //            spaceBetween: slider_ipad_horizontal_padding,
    //            slidesOffsetBefore: ipad_horizontal_offset
    //          },
    //          1100: {
    //            slidesPerView: desk_item,
    //            spaceBetween: slider_desktop_padding,
    //            slidesOffsetBefore: desktop_offset
    //          }
    //        }
    //      });
    //    }
    //    }
    //    if(desk_slider == 'true' && mob_slider == 'true' ){
    // }
    //  // Optionally, destroy the mobile slider if it is initialized on smaller screens (e.g., on resize)
    //    else{
    //  $(window).resize(function() {
    //    if (window.matchMedia("(min-width: 1100px)").matches) {
    //      // Destroy mobile swiper if it exists
    //      if (window.swiperInstance) {
    //        window.swiperInstance.destroy(true, true); // Example of destroying Swiper instance
    //      }
    //      // Re-initialize desktop swiper
    //      initializeDesktopSlider();
    //    } else {
    //      // Destroy desktop swiper if it exists
    //      if (window.swiperInstance) {
    //        window.swiperInstance.destroy(true, true);
    //      }
    //      // Initialize mobile swiper if it's enabled
    //      if (mob_slider == 'true') {
    //        initializeMobileSlider();
    //      }
    //    }
    //  });
    //    }
  });

  $(".ky_featured_collection_swiper").each(function () {
    ysscount++;
    var this_item = $(this);
    this_item.addClass("swiper customswiper2" + ysscount);

    var desk_item = parseInt(this_item.attr("data-desktop_items") || "1");
    var mob_item = parseInt(this_item.attr("data-mobile_items") || "1");
    var ipad_item_horizontal = parseInt(
      this_item.attr("data-ipad_horizontal_items") || "1"
    );
    var ipad_item_vertical = parseInt(
      this_item.attr("data-ipad_vertical_items") || "1"
    );

    var slider_desktop_padding = parseInt(
      this_item.attr("data-desktop-padding") || "0"
    );
    var slider_ipad_horizontal_padding = parseInt(
      this_item.attr("data-ipad-horizontal-padding") || "0"
    );
    var slider_ipad_vertical_padding = parseInt(
      this_item.attr("data-ipad-vertical-padding") || "0"
    );
    var slider_mobile_padding = parseInt(
      this_item.attr("data-mobile-padding") || "0"
    );

    var desktop_offset = parseInt(this_item.attr("data-desktop-offset") || "0");
    var mobile_offset = parseInt(this_item.attr("data-mobile-offset") || "0");
    var ipad_vertical_offset = parseInt(
      this_item.attr("data-ipad-vertical-offset") || "0"
    );
    var ipad_horizontal_offset = parseInt(
      this_item.attr("data-ipad-horizontal-offset") || "0"
    );

    // console.log("Mobile Settings:", { mob_item, slider_mobile_padding, mobile_offset });

    var partner_swiper = new Swiper(".customswiper2" + ysscount, {
      spaceBetween: 0,
      loop: false,
      autoplay: false,
      centeredSlides: false,
      breakpoints: {
        0: {
          slidesPerView: mob_item,
          spaceBetween: slider_mobile_padding,
          slidesOffsetBefore: mobile_offset,
        },
        481: {
          slidesPerView: ipad_item_vertical,
          spaceBetween: slider_ipad_vertical_padding,
          slidesOffsetBefore: ipad_vertical_offset,
        },
        786: {
          slidesPerView: ipad_item_horizontal,
          spaceBetween: slider_ipad_horizontal_padding,
          slidesOffsetBefore: ipad_horizontal_offset,
        },
        1100: {
          slidesPerView: desk_item,
          spaceBetween: slider_desktop_padding,
          slidesOffsetBefore: desktop_offset,
        },
      },
    });
  });

  $(".loaction_swiper").each(function () {
    ysscount++;
    var this_item = $(this);
    this_item.addClass("swiper customswiper3" + ysscount);
    var swiper = new Swiper(".loaction_swiper", {
      // pagination: {
      //   el: ".swiper-pagination",
      //   type: "fraction",
      // },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });

  $(".ky_custom_testimonial_swiper").each(function () {
    ysscount++;
    var this_item = $(this);
    this_item.addClass("swiper customswiper3" + ysscount);

    this_item.append(
      '<div class="swiper-button-next swiper_arrows2  customswiper_next' +
        ysscount +
        '"></div><div class="swiper-button-prev swiper_arrows2  customswiper_prev' +
        ysscount +
        '"></div>'
    );

    var desk_item = this_item.attr("data-desktop_items");
    var mob_item = this_item.attr("data-mobile_items");
    var ipad_item_horizontal = this_item.attr("data-ipad_horizontal_items");
    var ipad_item_vertical = this_item.attr("data-ipad_vertical_items");

    var slider_desktop_padding = this_item.attr("data-desktop-padding");
    var slider_ipad_horizontal_padding = this_item.attr(
      "data-ipad-horizontal-padding"
    );
    var slider_ipad_vertical_padding = this_item.attr(
      "data-ipad-vertical-padding"
    );
    var slider_mobile_padding = this_item.attr("data-mobile-padding");

    var partner_swiper = new Swiper(".customswiper3" + ysscount, {
      spaceBetween: 0,
      navigation: {
        nextEl: ".customswiper_next" + ysscount,
        prevEl: ".customswiper_prev" + ysscount,
      },
      loop: false,
      autoplay: false,
      centeredSlides: false,
      breakpoints: {
        0: {
          slidesPerView: mob_item,
          spaceBetween: slider_mobile_padding,
          //   slidesOffsetBefore: mobile_offset
        },
        481: {
          slidesPerView: ipad_item_vertical,
          spaceBetween: slider_ipad_vertical_padding,
          //   slidesOffsetBefore: ipad_vertical_offset
        },
        786: {
          slidesPerView: ipad_item_horizontal,
          spaceBetween: slider_ipad_horizontal_padding,
          //  slidesOffsetBefore: ipad_horizontal_offset
        },
        1100: {
          slidesPerView: desk_item,
          spaceBetween: slider_desktop_padding,
          // slidesOffsetBefore: desktop_offset
        },
      },
    });
  });
});

$(window).scroll(function () {
  if ($(window).scrollTop() > 0) {
    //$('.gototop').fadeIn(200);
    $("body").addClass("scrolled");
  } else {
    //$('.gototop').fadeOut(200);
    $("body").removeClass("scrolled");
  }
});

/**
 * jQuery.marquee - scrolling text like old marquee element
 * @author Aamir Afridi - aamirafridi(at)gmail(dot)com / http://aamirafridi.com/jquery/jquery-marquee-plugin
 */
/**
 * jQuery.marquee - scrolling text like old marquee element
 * @author Aamir Afridi - aamirafridi(at)gmail(dot)com / http://aamirafridi.com/jquery/jquery-marquee-plugin
 */
(function (f) {
  f.fn.marquee = function (x) {
    return this.each(function () {
      var a = f.extend({}, f.fn.marquee.defaults, x),
        b = f(this),
        c,
        t,
        e = 3,
        y = "animation-play-state",
        p = !1,
        E = function (a, b, c) {
          for (
            var e = ["webkit", "moz", "MS", "o", ""], d = 0;
            d < e.length;
            d++
          )
            e[d] || (b = b.toLowerCase()), a.addEventListener(e[d] + b, c, !1);
        },
        F = function (a) {
          var b = [],
            c;
          for (c in a) a.hasOwnProperty(c) && b.push(c + ":" + a[c]);
          b.push();
          return "{" + b.join(",") + "}";
        },
        l = {
          pause: function () {
            p && a.allowCss3Support
              ? c.css(y, "paused")
              : f.fn.pause && c.pause();
            b.data("runningStatus", "paused");
            b.trigger("paused");
          },
          resume: function () {
            p && a.allowCss3Support
              ? c.css(y, "running")
              : f.fn.resume && c.resume();
            b.data("runningStatus", "resumed");
            b.trigger("resumed");
          },
          toggle: function () {
            l["resumed" == b.data("runningStatus") ? "pause" : "resume"]();
          },
          destroy: function () {
            clearTimeout(b.timer);
            b.find("*").addBack().unbind();
            b.html(b.find(".js-marquee:first").html());
          },
        };
      if ("string" === typeof x)
        f.isFunction(l[x]) &&
          (c || (c = b.find(".js-marquee-wrapper")),
          !0 === b.data("css3AnimationIsSupported") && (p = !0),
          l[x]());
      else {
        var u;
        f.each(a, function (c, d) {
          u = b.attr("data-" + c);
          if ("undefined" !== typeof u) {
            switch (u) {
              case "true":
                u = !0;
                break;
              case "false":
                u = !1;
            }
            a[c] = u;
          }
        });
        a.speed && (a.duration = (parseInt(b.width(), 10) / a.speed) * 1e3);
        var v = "up" == a.direction || "down" == a.direction;
        a.gap = a.duplicated ? parseInt(a.gap) : 0;
        b.wrapInner('<div class="js-marquee"></div>');
        var h = b
          .find(".js-marquee")
          .css({ "margin-right": a.gap, float: "left" });
        a.duplicated && h.clone(!0).appendTo(b);
        b.wrapInner(
          '<div style="width:100000px" class="js-marquee-wrapper"></div>'
        );
        c = b.find(".js-marquee-wrapper");
        if (v) {
          var k = b.height();
          c.removeAttr("style");
          b.height(k);
          b.find(".js-marquee").css({
            float: "none",
            "margin-bottom": a.gap,
            "margin-right": 0,
          });
          a.duplicated &&
            b.find(".js-marquee:last").css({ "margin-bottom": 0 });
          var q = b.find(".js-marquee:first").height() + a.gap;
          a.startVisible && !a.duplicated
            ? ((a._completeDuration =
                ((parseInt(q, 10) + parseInt(k, 10)) / parseInt(k, 10)) *
                a.duration),
              (a.duration *= parseInt(q, 10) / parseInt(k, 10)))
            : (a.duration *=
                (parseInt(q, 10) + parseInt(k, 10)) / parseInt(k, 10));
        } else {
          var m = b.find(".js-marquee:first").width() + a.gap;
          var n = b.width();
          a.startVisible && !a.duplicated
            ? ((a._completeDuration =
                ((parseInt(m, 10) + parseInt(n, 10)) / parseInt(n, 10)) *
                a.duration),
              (a.duration *= parseInt(m, 10) / parseInt(n, 10)))
            : (a.duration *=
                (parseInt(m, 10) + parseInt(n, 10)) / parseInt(n, 10));
        }
        a.duplicated && (a.duration /= 2);
        if (a.allowCss3Support) {
          h = document.body || document.createElement("div");
          var g = "marqueeAnimation-" + Math.floor(1e7 * Math.random()),
            A = ["Webkit", "Moz", "O", "ms", "Khtml"],
            B = "animation",
            d = "",
            r = "";
          h.style.animation && ((r = "@keyframes " + g + " "), (p = !0));
          if (!1 === p)
            for (var z = 0; z < A.length; z++)
              if (void 0 !== h.style[A[z] + "AnimationName"]) {
                h = "-" + A[z].toLowerCase() + "-";
                B = h + B;
                y = h + y;
                r = "@" + h + "keyframes " + g + " ";
                p = !0;
                break;
              }
          p &&
            ((d =
              g +
              " " +
              a.duration / 1e3 +
              "s " +
              a.delayBeforeStart / 1e3 +
              "s infinite " +
              a.css3easing),
            b.data("css3AnimationIsSupported", !0));
        }
        var C = function () {
            c.css(
              "transform",
              "translateY(" +
                ("up" == a.direction ? k + "px" : "-" + q + "px") +
                ")"
            );
          },
          D = function () {
            c.css(
              "transform",
              "translateX(" +
                ("left" == a.direction ? n + "px" : "-" + m + "px") +
                ")"
            );
          };
        a.duplicated
          ? (v
              ? a.startVisible
                ? c.css("transform", "translateY(0)")
                : c.css(
                    "transform",
                    "translateY(" +
                      ("up" == a.direction
                        ? k + "px"
                        : "-" + (2 * q - a.gap) + "px") +
                      ")"
                  )
              : a.startVisible
              ? c.css("transform", "translateX(0)")
              : c.css(
                  "transform",
                  "translateX(" +
                    ("left" == a.direction
                      ? n + "px"
                      : "-" + (2 * m - a.gap) + "px") +
                    ")"
                ),
            a.startVisible || (e = 1))
          : a.startVisible
          ? (e = 2)
          : v
          ? C()
          : D();
        var w = function () {
          a.duplicated &&
            (1 === e
              ? ((a._originalDuration = a.duration),
                (a.duration = v
                  ? "up" == a.direction
                    ? a.duration + k / (q / a.duration)
                    : 2 * a.duration
                  : "left" == a.direction
                  ? a.duration + n / (m / a.duration)
                  : 2 * a.duration),
                d &&
                  (d =
                    g +
                    " " +
                    a.duration / 1e3 +
                    "s " +
                    a.delayBeforeStart / 1e3 +
                    "s " +
                    a.css3easing),
                e++)
              : 2 === e &&
                ((a.duration = a._originalDuration),
                d &&
                  ((g += "0"),
                  (r = f.trim(r) + "0 "),
                  (d =
                    g +
                    " " +
                    a.duration / 1e3 +
                    "s 0s infinite " +
                    a.css3easing)),
                e++));
          v
            ? a.duplicated
              ? (2 < e &&
                  c.css(
                    "transform",
                    "translateY(" +
                      ("up" == a.direction ? 0 : "-" + q + "px") +
                      ")"
                  ),
                (t = {
                  transform:
                    "translateY(" +
                    ("up" == a.direction ? "-" + q + "px" : 0) +
                    ")",
                }))
              : a.startVisible
              ? 2 === e
                ? (d &&
                    (d =
                      g +
                      " " +
                      a.duration / 1e3 +
                      "s " +
                      a.delayBeforeStart / 1e3 +
                      "s " +
                      a.css3easing),
                  (t = {
                    transform:
                      "translateY(" +
                      ("up" == a.direction ? "-" + q + "px" : k + "px") +
                      ")",
                  }),
                  e++)
                : 3 === e &&
                  ((a.duration = a._completeDuration),
                  d &&
                    ((g += "0"),
                    (r = f.trim(r) + "0 "),
                    (d =
                      g +
                      " " +
                      a.duration / 1e3 +
                      "s 0s infinite " +
                      a.css3easing)),
                  C())
              : (C(),
                (t = {
                  transform:
                    "translateY(" +
                    ("up" == a.direction ? "-" + c.height() + "px" : k + "px") +
                    ")",
                }))
            : a.duplicated
            ? (2 < e &&
                c.css(
                  "transform",
                  "translateX(" +
                    ("left" == a.direction ? 0 : "-" + m + "px") +
                    ")"
                ),
              (t = {
                transform:
                  "translateX(" +
                  ("left" == a.direction ? "-" + m + "px" : 0) +
                  ")",
              }))
            : a.startVisible
            ? 2 === e
              ? (d &&
                  (d =
                    g +
                    " " +
                    a.duration / 1e3 +
                    "s " +
                    a.delayBeforeStart / 1e3 +
                    "s " +
                    a.css3easing),
                (t = {
                  transform:
                    "translateX(" +
                    ("left" == a.direction ? "-" + m + "px" : n + "px") +
                    ")",
                }),
                e++)
              : 3 === e &&
                ((a.duration = a._completeDuration),
                d &&
                  ((g += "0"),
                  (r = f.trim(r) + "0 "),
                  (d =
                    g +
                    " " +
                    a.duration / 1e3 +
                    "s 0s infinite " +
                    a.css3easing)),
                D())
            : (D(),
              (t = {
                transform:
                  "translateX(" +
                  ("left" == a.direction ? "-" + m + "px" : n + "px") +
                  ")",
              }));
          b.trigger("beforeStarting");
          if (p) {
            c.css(B, d);
            var h = r + " { 100%  " + F(t) + "}",
              l = c.find("style");
            0 !== l.length
              ? l.filter(":last").html(h)
              : f("head").append("<style>" + h + "</style>");
            E(c[0], "AnimationIteration", function () {
              b.trigger("finished");
            });
            E(c[0], "AnimationEnd", function () {
              w();
              b.trigger("finished");
            });
          } else
            c.animate(t, a.duration, a.easing, function () {
              b.trigger("finished");
              a.pauseOnCycle
                ? (b.timer = setTimeout(w, a.delayBeforeStart))
                : w();
            });
          b.data("runningStatus", "resumed");
        };
        b.bind("pause", l.pause);
        b.bind("resume", l.resume);
        a.pauseOnHover &&
          (b.bind("mouseenter", l.pause), b.bind("mouseleave", l.resume));
        p && a.allowCss3Support
          ? w()
          : (b.timer = setTimeout(w, a.delayBeforeStart));
      }
    });
  };
  f.fn.marquee.defaults = {
    allowCss3Support: !0,
    css3easing: "linear",
    easing: "linear",
    delayBeforeStart: 1e3,
    direction: "left",
    duplicated: !1,
    duration: 5e3,
    gap: 20,
    pauseOnCycle: !1,
    pauseOnHover: !1,
    startVisible: !1,
  };
})(jQuery);

$(document).ready(function () {
  $(".rotating_text").marquee({
    gap: 100,
    delayBeforeStart: 0,
    startVisible: true,
    direction: "left",
    duplicated: true,
    speed: 15,
    pauseOnHover: true,
  });

  $(".rotating_text2").marquee({
    gap: 50,
    delayBeforeStart: 0,
    startVisible: true,
    direction: "left",
    duplicated: true,
    speed: 50,
    pauseOnHover: true,
  });
});

$(document).ready(function () {
  $(".tabs").click(function () {
    var tabId = $(this).data("tab");

    // Remove 'active' class from all tabs
    $(".tabs").removeClass("active");

    // Add 'active' class to the clicked tab
    $(this).addClass("active");

    // Hide all tab contents
    $(".tab-content").removeClass("active").hide();

    // Show the clicked tab's content
    $("#" + tabId)
      .addClass("active")
      .show();
  });

  // Trigger click on the first tab to show on page load
  $(".tabs").first().click();
});

$(document).ready(function () {
  $(".accordion-header").on("click", function () {
    // Close all other content and reset their icons
    $(".accordion-content").slideUp();
    $(".accordion-header")
      .removeClass("active")
      .find(".accordion-icon")
      .html(
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z" fill="#D2D2D2"/></svg>'
      ); // Reset to default "+"

    // Toggle the clicked item's content
    const content = $(this).next(".accordion-content");
    if (content.is(":hidden")) {
      content.slideDown();
      $(this).addClass("active").find(".accordion-icon")
        .html(`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 11H19V13H5V11Z" fill="#D2D2D2"/>
              </svg>`); // Minus icon
    }
  });
});

$(".modal-toggles").on("click", function (e) {
  $(".bmodal").toggleClass("is-visible");
});

$(document).ready(function () {
  (count = 0),
    $(".show_hide_content").each(function () {
      console.log("Shiv"),
        (count = count + 1),
        $(".show_hide_content").wrapInner(
          '<div class="full_wrap seo_inner_content" id="content_inner_' +
            count +
            '"></div>'
        ),
        $(".show_hide_content").append(
          '<button href="javascript:void(0);" class="show_hide_anchor" data-id="content_inner_' +
            count +
            '">+ Show More</button>'
        );
    }),
    $(document).on("click", ".show_hide_anchor", function () {
      if (
        ($(this).toggleClass("active"),
        $(this).hasClass("active")
          ? $(this).text("- Show Less")
          : $(this).text("+ Show More"),
        $(this)
          .parents(".show_hide_content")
          .find(".seo_inner_content")
          .toggleClass("active"),
        $(this)
          .parents(".show_hide_content")
          .find(".seo_inner_content")
          .hasClass("active"))
      ) {
        id = $(this).attr("data-id");
        var content = document.getElementById(id),
          contentHeight = content.scrollHeight;
        content.style.maxHeight = contentHeight + "px";
      } else (id = $(this).attr("data-id")), $("#" + id).removeAttr("style");
    });
});

$(document).ready(function () {
  $(".store_icon").on("click", function (event) {
    event.stopPropagation();
    $(".store_location").toggle();
  });

  $(document).on("click", function (event) {
    if (!$(event.target).closest(".store_parent").length) {
      $(".store_location").hide();
    }
  });

  $(".store_parent").hover(
    function () {
      $(".store_location").show();
    },
    function () {
      $(".store_location").hide();
    }
  );
});

$(document).ready(function () {
  $("ul li .video_img_wrap img").attr("alt", "Jewellery");
});

$(".gallery-item").magnificPopup({
  type: "image",
  // other options
});
